import StatusButton from "./StatusButton";
import CustomTable from "../table";

export default function ExpiredTable({ data }) {
  const columns = [
    {
      title: "Order id",
      dataIndex: "orderId",
    },
    {
      title: "Subscription",
      dataIndex: "subscriptionName",
    },
    {
      title: "Customer",
      dataIndex: "customerName",
    },
    {
      title: "Total",
      dataIndex: "totalAmount",
    },
    {
      title: "Start Date",
      dataIndex: "subscriptionStartDate",
    },
    {
      title: "End Date",
      dataIndex: "subscriptionEndDate",
    },
    {
      title: "Next payment",
      dataIndex: "subscriptionRenewalDate",
    },
    {
      title: "Status",
      render: (rowData) => {
        return (
          <>
            <div>
              <StatusButton status={"expired"}>
                {rowData.subscriptionStatus}
              </StatusButton>
            </div>
          </>
        );
      },
    },
  ];
  return (
    <CustomTable columns={columns} title="Expired Subscriptions" data={data} />
  );
}
